import { Component, Inject, OnInit, Optional } from '@angular/core';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { Item } from '@app/core/components/listbox/listbox.component';
import { SrCrewMenuGet, SrCrewService } from '@app/services/sr-crew.service';

@Component({
    selector: 'tt-sr-crew-menu',
    templateUrl: './sr-crew-menu.component.html',
    styleUrls: ['./sr-crew-menu.component.css'],
    standalone: false,
})
export class SrCrewMenuComponent implements OnInit {
    public page?: SrCrewMenuGet;
    public selectedTab = 'BASIS';
    public memberships: Item[] = [];

    constructor(
        private readonly crew: SrCrewService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) { this.navigator = useNavigatorFor(navigator, this); }

    public async ngOnInit(): Promise<void> {
        const params = {
            resource_id: String(this.navigator?.params['resource_id'] ?? ''),
            srcrew_keyno: String(this.navigator?.params['srcrew_keyno'] ?? '0'),
        };
        const [page, memberships] = await Promise.all([this.crew.getMenu(params), this.crew.getMemberships({ srcrew_keyno: params.srcrew_keyno })]);
        this.page = page;
        this.memberships = memberships;
    }
}
